export default {
  methods: {
    makePlural (counter, singular, plural) {
      return counter === 1 ? singular : plural
    },
  },
}
